import { observable } from "mobx";

const commonStore = observable(
  {
    loadingCount: 0,

    get isLoading() {
      return this.loadingCount > 0;
    },

    setIsLoading(isLoading) {
      this.loadingCount = isLoading
        ? this.loadingCount + 1
        : Math.max(0, this.loadingCount - 1);
    },
  }
);

export default commonStore;
